import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("选择文件")
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("选择文件")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_app_ellipsis = _resolveComponent("app-ellipsis")!
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.mode === 'DESIGN')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_el_button, {
            size: "default",
            icon: "Paperclip",
            round: ""
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_component_app_ellipsis, {
            row: 1,
            content: _ctx.placeholder + _ctx.sizeTip,
            "hover-tip": "",
            class: "el-upload__tip"
          }, null, 8, ["content"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_el_upload, {
            "file-list": _ctx._value,
            action: "#",
            limit: _ctx.maxSize,
            "with-credentials": "",
            multiple: _ctx.maxSize > 0,
            data: _ctx.uploadParams,
            "auto-upload": false,
            "before-upload": _ctx.beforeUpload,
            "http-request": _ctx.requestUpload
          }, {
            tip: _withCtx(() => [
              _createVNode(_component_app_ellipsis, {
                row: 1,
                content: _ctx.placeholder + _ctx.sizeTip,
                "hover-tip": "",
                class: "el-upload__tip"
              }, null, 8, ["content"])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                size: "default",
                icon: "Paperclip",
                round: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["file-list", "limit", "multiple", "data", "before-upload", "http-request"])
        ]))
  ]))
}